import React from 'react';

const Testimonials = () => {
  return (
    <div className="page-container">
      <h1>Testimonials... Comming Soon...</h1>
      {/* <p>This is the Testimonials page content.</p> */}
    </div>
  );
};

export default Testimonials;
